import React from 'react';
import AgenteRetencionEmpresa from '../components/contabilidad/AgenteRetencionEmpresa';
import RetencionIslrCodigos from '../components/contabilidad/RetencionIslrCodigos';
import BotonAyuda from '../components/BotonAyuda';

// Datos maestros contables/fiscales compartidos por todas las empresas
// (conceptos de retención ISLR) y agente de retención de la empresa activa.
// Antes vivían en Administración.
export default function ConfiguracionContable() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-800">Configuración contable<BotonAyuda /></h1>
      <AgenteRetencionEmpresa />
      <RetencionIslrCodigos />
    </div>
  );
}
